import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  gruposDeRotas: [],
  grupoDeRotas: {},
  grupoDeRotasUse: {},
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}